import {Component, EventEmitter, Input, NgZone, OnInit, Output} from '@angular/core';
import {StorageService} from 'src/app/share/services/storage-service/storage.service';
import {AuthService} from '../auth/auth.service';
import {StorageKeys} from '../../share/enums/storage.enum';
import {environment} from '../../../environments/environment';
// @ts-ignore
import {Tooltip} from 'bootstrap/dist/js/bootstrap.esm.js';
import { faAngleDown, faAngleUp, faChevronDown, faChevronUp, faCodeBranch, faUserCircle} from '@fortawesome/free-solid-svg-icons';
import {UserSettingService} from 'src/app/share/services/User-Setting/user-setting.service';
import {faSignOut} from "@fortawesome/free-solid-svg-icons/faSignOut";
import {Router, NavigationEnd} from "@angular/router";
import {RouteConstants} from 'src/app/share/constants/routes.constants';
import {SdexAdminService} from 'src/app/share/services/sdex/sdex-admin.service';
import {userSelfDetails} from '../../user-storage';
import {adminSideBarList, companySideBarList} from './admin';
import {CommonService} from 'src/app/share/services/common/common.service';
import {ShipmentServiceService} from 'src/app/share/services/shipment/shipment-service.service';
import {DocumentValutService} from 'src/app/share/document-valut/document-valut.service'
import { InAppNotificationsService } from 'src/app/share/services/in-app-notifications/in-app-notifications.service';
import { SelectedOrgService } from 'src/app/share/services/selected-org.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {
  @Input() isExpanded       : boolean = false;
  @Output() toggleSidebar   : EventEmitter<boolean> = new EventEmitter<boolean>();
  enrollmentType            : any;
  selectedCompany           : any;
  bootstrap                 : any;
  userDetailsData           : any;
  profilePic                : any;
  user                      : any = {};
  selectedMenuItem          : number = 1;
  name                      : string
  verifyLoader              : boolean = false;
  isSubMenuActive           : boolean = false;
  showTooltip               : boolean = false;
  hideText                  : boolean = false;
  buttonText                : string = '<';
  sideBarList               : any[] = [];
  userCircleIcon            = faUserCircle;
  materialEnabled: boolean = false;
  tgsrtcEnabled: boolean = false;
  entityType: any;
  protected readonly faSignOut = faSignOut;
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;
  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;
  faCodeBranch = faCodeBranch;
  prefs:any;
  isDamsHost: boolean = false;
  notificationCount: number = 0;
  companyListForAutoSearch: { _id: string; name: string }[] = [];
  isEditingCompany: boolean = false;

  constructor(
    private readonly storageService: StorageService,
    public  authService: AuthService,
    private readonly userSettingService: UserSettingService,
    private readonly router: Router,
    public sdexAdminService: SdexAdminService,
    private readonly commonService: CommonService,
    private readonly ngZone: NgZone,
    private readonly shipmentServiceService:ShipmentServiceService,
    private readonly documentValutService : DocumentValutService,
    private readonly notificationsService: InAppNotificationsService,
    private readonly selectedOrgService: SelectedOrgService
  ) { }

  loadSideBar() {
    const host = (typeof window !== 'undefined' ? window.location?.hostname : '') ?? '';
    this.isDamsHost = host.includes('dams.dev.sdex.in');
    if (this.userDetailsData?.enrollmentType === 'Admin') {
      this.sideBarList = adminSideBarList(environment?.envType);
    } else {
      this.sideBarList = companySideBarList(environment?.envType, this.authService.isCompanyAdmin(), this.userDetailsData?.primary, this.userDetailsData, this.authService, this.materialEnabled, this.tgsrtcEnabled, this.entityType,this.isDamsHost,this.prefs);
    }
  }

  setPrefVariables(){
    this.userSettingService.setPrefDetails(this.prefs);
    this.materialEnabled = this.prefs?.material?.enabled || false;
    this.tgsrtcEnabled = this.prefs?.tgsrtc?.enabled || false;
    const entityPref = this.prefs?.serviceType?.entity;
    if (typeof entityPref === 'string' && entityPref.trim() !== '') {
      this.entityType = entityPref.split(',').map(e => e.trim()).filter(Boolean);
    } else if (Array.isArray(entityPref)) {
      this.entityType = entityPref.filter(Boolean);
    }
  }

  ngOnInit() {
    this.prefs = this.storageService.getDataFromLocalStorage(StorageKeys.PREFERENCES);
    if(this.prefs){
      this.setPrefVariables()
    }else{
      this.getCompanyPrefs();
    }
    this.commonService.getReloadSidebar().subscribe(value => {
      if(value){
        this.getSelfDetails();
      }
    })
    this.getSelfDetails();
    Array.from(
      document.querySelectorAll('button[data-bs-toggle="tooltip"]')
    ).forEach((tooltipNode) => new Tooltip(tooltipNode));

    this.userSettingService.getProfilePic().subscribe((res: any) => {
      this.profilePic = res;
    })
    this.userSettingService.getUpdatedUserName().subscribe((res: any) => {
      this.userDetailsData.name = res;
    });

    this.userSettingService.getPrefDetails().subscribe((res: any) => {
      this.prefs = res;
    });

    const shouldCollapseForUrl = (url: string | undefined) => {
      if (!url) { return; }
      const isChatbot = url.includes(`/${RouteConstants.Chatbot}`);
      if (isChatbot) {
        this.hideText = true;
        this.buttonText = '>';
        this.showTooltip = true;
      }
    };
    shouldCollapseForUrl(this.router.url);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects || event.url;
        shouldCollapseForUrl(url);
        this.loadSideBar();
        const documentVault = url.includes('/document-vault');
        if (!documentVault) {        
          this.commonService.setSelectedOrg('');
        }
      }
    });
    this.getNotificationCount();
    this.notificationsService.subscribe().subscribe(event => {
    if (event.event === 'NOTIFICATION_COUNT_UPDATED') {
      this.notificationCount = event.data;
    }
  });
  }

  handleSidebarToggle = () => this.toggleSidebar.emit(!this.isExpanded);

  toggleSubMenu() {
    this.isSubMenuActive = !this.isSubMenuActive;
  }

  isMenuItemActive(index: number): boolean {
    return this.selectedMenuItem === index;
  }

  toggleDropdown(item: any) {
    if (item.subItems) {
      item.isOpen = !item.isOpen;
    }
  }

  getSelfDetails() {
    userSelfDetails(this.authService, this.sdexAdminService, this.storageService, this.userSettingService, environment?.envType, (selfDetails: any) => {
      if (selfDetails) {
        this.userDetailsData = selfDetails;
        this.profilePic = this.userDetailsData?.profileImage;
      }
      this.user = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
      this.selectedCompany = this.user?.company;
      this.updateCompanyListForAutoSearch();
      this.loadSideBar();
    });
  }

  logout() {
    this.verifyLoader = true;
    this.authService.logout().subscribe({
      next: () => {
        const bc = new BroadcastChannel('sdex-web-app');
        bc.postMessage('logOut');
        bc.close();
        this.performLogoutCleanup();
      },
      error: () => this.performLogoutCleanup()
    });
  }

  performLogoutCleanup() {
    this.selectedOrgService.setSelectedOrg(null);
    this.documentValutService.parentDirectory = '';
    localStorage.clear();
    this.verifyLoader = false;
    this.ngZone.run(() => {
      this.router.navigate([RouteConstants.Login]);
    });
  }

  toggleTextVisibility() {
    this.hideText = !this.hideText;
    this.buttonText = this.hideText ? '>' : '<';
    this.showTooltip = !this.showTooltip;
  }

  hideListText() {
    this.hideText = true
    this.buttonText = '>'
    this.showTooltip = true
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }

  applyCompanySelection(companyId: string, reload: boolean = true) {
    this.getNotificationCount();
      this.user = this.storageService.getDataFromLocalStorage(
        StorageKeys.SELF_DETAILS
      );
      this.selectedCompany = companyId;
      if (this.user) {
        this.user.company = this.selectedCompany;
        for (const assigned of (this.user?.assignedTo || [])) {
          if ((assigned.company._id === this.user.company) && this.user.company) {
            this.user.presentRoles = assigned.roles || [];
          }
        }
        this.storageService.setDataToLocalStorage(
          StorageKeys.PRESENT_COMPANY,
          this.selectedCompany
        );
        this.storageService.setDataToLocalStorage(
          StorageKeys.SELF_DETAILS,
          this.user
        );
        this.ngZone.run(() => {
          this.router.navigate(['/user-setting/user-profile']);
          if(reload){
            setTimeout(()=>{
              location.reload();
            })
          }
        });
    }
  }
  scrollTo() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }

  getCompanyPrefs(){
    this.userSettingService.getCompanyPrefs().subscribe({
      next:(res: any)=>{
        if(res.data){
          this.prefs = res.data;
          this.userSettingService.setPrefDetails(this.prefs);
          this.storageService.setDataToLocalStorage(StorageKeys.PREFERENCES,res.data);
          this.setPrefVariables();
        }
      }
    })
  }

  getNotificationCount() {
    this.notificationsService.getNotificationUnReadCount()?.subscribe({
      next: (res: any) => {
        this.notificationCount = res?.data?.unreadCount;
      },
      error: (error: any) => {
      }
    });
  }

  updateCompanyListForAutoSearch(): void {
    if (!this.user?.assignedTo?.length) {
      this.companyListForAutoSearch = [];
      return;
    }
    this.companyListForAutoSearch = this.user.assignedTo.map((a: any) => (
      {
        _id: a.company._id,
        name: `${a.company.name} (${a.parentCompanyName})`
      }));
  }

  get selectedCompanyDisplayName(): string | null {
    if (!this.selectedCompany || !this.user?.assignedTo?.length) return null;
    const assigned = this.user.assignedTo.find((a: any) => a.company._id === this.selectedCompany);
    return assigned ? `${assigned.company.name} (${assigned.parentCompanyName ?? ''})` : null;
  }

  onCompanyChange(event: any, reload: boolean = true) {
    const companyId = event?.target?.value;
    if (companyId) {
      this.applyCompanySelection(companyId, reload);
    }
  }

  onCompanySelectFromAutoSearch(selected: any) {
    if (selected?._id) {
      this.applyCompanySelection(selected._id, true);
    }
  }

  toggleEditCompany() {
    this.isEditingCompany = !this.isEditingCompany;
  }
}
